// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__fzSza","content":"message_content__vHYM1"};